import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function SingleSelectSearch({ options = [], label, onChange, name, value }) {
  const selectedValue = Array.isArray(value) ? value[0] || "" : value || "";

  return (
    <Autocomplete
      options={options}
      value={selectedValue}
      onChange={(_event, newValue) => {
        onChange({ target: { name, value: newValue || "" } });
      }}
      onInputChange={(_event, newInputValue, reason) => {
        if (reason === "input") {
          onChange({ target: { name, value: newInputValue || "" } });
        }
      }}
      size="small"
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label={label} size="small" />
      )}
    />
  );
}
